import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Rxjs import
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// 3rd party imports
import { plainToClass } from 'class-transformer';
import { MPCacheRegistrationService } from '../shared-services/mp-cache-registration-service';

// Constants imports
import { CacheDuration } from '../../_constants/cache-duration';
import { URLConstants } from '../../_constants/url-constants';

// models imports
import { UserContextTreeResultDto } from '../../_models/user-context-tree-result-dto';
import { UserContextTreeParametersDto } from '../../_models/user-context-tree-parameters-dto';

@Injectable({
    providedIn: 'root'
})
export class UserContextTreeService {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly cacheRegistrationService: MPCacheRegistrationService
    ) {}

    getUserContextTree(param: UserContextTreeParametersDto): Observable<UserContextTreeResultDto[]> {
        const url = URLConstants.ccUserBaseApiUrl + `/context${param.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, param.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get<UserContextTreeResultDto[]>(url, options)
            .pipe(map((response: UserContextTreeResultDto[]) => plainToClass(UserContextTreeResultDto, response)));
    }
}
